import { render, staticRenderFns } from "./License.vue?vue&type=template&id=c1041aa6&scoped=true&"
import script from "./License.vue?vue&type=script&lang=js&"
export * from "./License.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1041aa6",
  null
  
)

export default component.exports